export default "__VITE_ASSET__DOuDpx1H__"